import { graphql } from '@/gql';

graphql(`
  fragment HomeServiceOrderProviderFragment on HomeServiceOrderProviderType {
    id
    homeServiceOrderId
    homeServiceProviderId
    role
    acceptedAt
    isCurrentProvider
    assignedBy
    assignmentNotes
    assignedAt
    removedAt
    createdAt
    updatedAt
  }
`);
